import { BaseWithId } from '@app/shared/models/base';
import { ClientLocale } from '@app/shared/models/client';

export class UserCountry extends BaseWithId {
    display_name: string
    iso_code: string;
    locale: ClientLocale;
    name: string;
    vat: number;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            locale: new ClientLocale(json && json.locale)
        });
    }
}
